/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import LayoutFooter from "../inc/LayoutFooter";
import LayoutHeader from "../inc/LayoutHeader";
import { useNavigate, useParams } from "react-router-dom";
import { Layout, Col, Row } from "antd";
import { Button, Card, Form, Input } from "antd";
import { displayMessage, postAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { EDIT_USER, USER_DETAIL } from "../../constants/api";

function EditUser() {
  const { Content } = Layout;
  let history = useNavigate();
  const { id } = useParams();

  const [state, setstate] = useState(null);
  const [loading, setloading] = useState(true);
  const [form] = Form.useForm();

  useLayoutEffect(() => {
    if (state === null) {
      getDetail();
    }
  }, [
    state,
    form.setFieldsValue({
      name: state != null ? state["name"] : "",
      email: state != null ? state["email"] : "",
      password: state != null ? state["password"] : "",
    }),
  ]);

  const getDetail = () => {
    const postData = new FormData();
    postData.append("id", id);
    const successFn = function (data) {
      console.log(data);
      setstate(data["data"]);
      setloading(false);
      console.log(state);
    };
    const errorFn = function () {
      displayMessage(ERROR_MSG_TYPE, "Unable to get detail");
    };
    postAPI(USER_DETAIL, postData, successFn, errorFn);
  };

  const createCategory = (values) => {
    console.log(values);

    const data = new FormData();
    data.append("id", state.id);

    if (values.name) {
      data.append("name", values.name);
    }
    if (values.email) {
      data.append("email", values.email);
    }
    if (values.password) {
      data.append("password", values.password);
    }
    const successFn = function (data) {
      console.log(data);
      if (data["status"] === true) {
        history("/user");
        displayMessage(SUCCESS_MESSAGE, "Data Saved Successfully");
      } else {
        displayMessage(ERROR_MSG_TYPE, data["message"]);
      }
    };
    const errorFn = function () {
      displayMessage(ERROR_MSG_TYPE, "Unable to Update Data");
    };
    postAPI(EDIT_USER, data, successFn, errorFn);
  };
  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card loadin={loading} title="Edit User" bordered={false}>
            <Form onFinish={createCategory} form={form}>
              <Form.Item style={{ marginBottom: 0 }}>
                <Row spceber>
                  <Col span={12}>
                    <Form.Item
                      name="name"
                      label="Full Name"
                      rules={[{ required: false }]}
                      style={{ marginRight: "5px" }}
                    >
                      <Input
                        style={{ height: "35px" }}
                        type={"text"}
                        placeholder="Full Name"
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      name="email"
                      label="Email"
                      rules={[{ required: false }]}
                      style={{ marginRight: "5px" }}
                    >
                      <Input
                        style={{ height: "35px" }}
                        type={"text"}
                        placeholder="Email"
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row spceber>
                  <Col span={24}>
                    <Form.Item
                      name="password"
                      label="Password"
                      rules={[{ required: false }]}
                      style={{ marginRight: "5px" }}
                    >
                      <Input
                        style={{ height: "35px" }}
                        type={"text"}
                        placeholder="Password"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>
              <Row spceber>
                <Col span={24}>
                  <Form.Item style={{ float: "right" }} label="" colon={false}>
                    <Button block htmlType="submit">
                      Submit User
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}
export default EditUser;
